import { _t } from './base'

function moveProductElements(product) {
    const availability = product.find('.ratings-wrapper .availability')
    const prices = product.find('.prices')
    const pTools = product.find('.p-tools')
    const image = product.find('.image')
    const pCode = product.find('.p-code')

    // Create wrapper and move availability and p-code into it
    const availabilityWrapper = $('<div class="availability-wrapper"></div>')
    availability.wrap(availabilityWrapper)

    pCode.appendTo(availability.parent())

    // Move the wrapper after prices
    availability.parent().insertAfter(prices)

    // Handle short description based on "Expirace" text
    const shortDescription = product.find('.p-desc')
    if (shortDescription.length) {
        const descText = shortDescription.text()
        if (descText.includes('Expirace')) {
            shortDescription.text(descText.replace('...', ''))
            shortDescription.addClass('expiration-date')
        } else {
            shortDescription.css('visibility', 'hidden')
        }
    }

    product.find('.price-standard').appendTo(product.find('.price.price-final'))

    // Change cart text
    product.find('.add-to-cart-button span').text(_t('product.cartBtn'))
}

function discountFlags(product) {
    const save = product.find('.price-save')
    const prices = product.find('.prices')
    const image = product.find('.image')

    // Discount flags
    if (save.length && !product.find('.flag-save').length) {
        const saveText = save.text().replace(/[()]/g, '')
        const flagsDefault = product.find('.flags-default')

        if (flagsDefault.length) {
            flagsDefault.prepend(`
                    <span class="flag flag-save">
                        ${saveText}
                    </span>
                `)
        } else {
            image.append(`
                    <div class="flags flags-default">
                        <span class="flag flag-save">
                            ${saveText}
                        </span>
                    </div>
                `)
        }

        save.insertAfter(prices)
    }
}

function addProductExpiredDate() {
    $(document).on('click', '.product .btn.add-to-cart-button', function () {
        const product = $(this).closest('.product')
        const productId = product.find('.p-code span').text()

        // Try to find expiration date
        let expirationDate = null
        const expirationText = product.find('.p-desc.expiration-date').text().trim()
        if (expirationText) {
            expirationDate = expirationText
        }

        // Get existing data or initialize empty array
        const existingData = JSON.parse(localStorage.getItem('productsExpirationData') || '[]')

        // Create new product entry
        const newProduct = {
            id: productId,
            expirationDate: expirationDate,
        }

        // Update or add the product data
        const existingIndex = existingData.findIndex((item) => item.id === productId)
        if (existingIndex >= 0) {
            existingData[existingIndex] = newProduct
        } else {
            existingData.push(newProduct)
        }

        // Save back to localStorage
        localStorage.setItem('productsExpirationData', JSON.stringify(existingData))
    })
}

function addProductHoverEffect(product) {
    const productElement = product.get(0) // Get the actual DOM element

    product.find('.image img:not(.parameters-image)').css({
        transition: 'transform 0.3s ease',
    })

    product.hover(
        function () {
            $(this).find('.image img:not(.parameters-image)').css('transform', 'scale(1.1)')
        },
        function () {
            $(this).find('.image img:not(.parameters-image)').css('transform', 'scale(1)')
        }
    )
}

export const transformProducts = () => {
    const products = $('.products-block .product')

    if (products.length) {
        products.each(function () {
            const product = $(this)

            // Přepozicování elementů
            moveProductElements(product)
            discountFlags(product)
            addProductHoverEffect(product)
        })
        addProductExpiredDate()
    }
}

export function initProducts() {
    transformProducts()

    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        transformProducts()
    })
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
        transformProducts()
    })
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
        transformProducts()
    })
}
